import * as yup from 'yup';

import { budgetValidationSchema } from '../../components/ad-campaign/budget-section/AdCampaignBudgetFormModal/budgetAndBidValidationSchema';
import { schedulesValidationSchema } from '../../components/ad-campaign/schedule-section/adCampaignScheduleValidationSchema';

export const adCampaignFormValidationSchema = yup
  .object({
    agreementTermsAndConditions: yup.boolean().required(),
  })
  .concat(budgetValidationSchema.concat(schedulesValidationSchema));
